import script from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-email-form.vue?vue&type=script&lang=ts&setup=true"

import "./auth-email-form.vue?vue&type=style&index=0&id=5c03b8d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c03b8d9"]])

export default __exports__